import { getInStockVariants } from "../../utils/variantUtils";

export const getTotalInStock = ({ variants }) =>
  getInStockVariants(variants).length;
